import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function DMMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.dm.home);
  };

  return (
    <MainMenuItem
      itemTitleString="ダイレクト\nメール"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default DMMenuItem;
